module.exports = __webpack_public_path__ + "static/media/SimplyWallSt.a16c94cc.png";